module.exports = __webpack_public_path__ + "static/img/sedan-grey.8cbac23.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/sedan-grey.svg
// module id = rjFs
// module chunks = 74